import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { businessFunctionByOriginalName, BusinessFunctionUtils } from '../utils/business-function-utils';
import { GetApprovableBusinessFunctionsResponse } from '@backbase/data-ang/approvals';

@Injectable()
export class BusinessFunctionInterceptor extends BusinessFunctionUtils implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      map((event) => {
        if (
          request.url.indexOf('/api/approval-service/client-api/v2/policy-assignments/approvable-business-functions') >
            -1 &&
          request.method === 'GET'
        ) {
          if (event instanceof HttpResponse) {
            let body = event.body as GetApprovableBusinessFunctionsResponse;
            let approvableBusinessFunctions = body.approvableBusinessFunctions.filter(
              (b) => !!businessFunctionByOriginalName[b.function],
            );

            approvableBusinessFunctions = this.getBusinessFunctionWithTranslations(approvableBusinessFunctions);
            return event.clone({
              body: { ...event.body, approvableBusinessFunctions },
            });
          }
        }
        return event;
      }),
    );
  }
}
